module.exports = __webpack_public_path__ + "static/img/nacos.147e9bf5.svg";